import { signupFormSiteTypes } from "@redotech/redo-model/signup-form";
import { z } from "zod";
export const getSignupFormSchema = {
  input: z.object({
    shopifyCustomerId: z.string().nullable(),
    customerHash: z.string(),
    formId: z.string().nullable(),
    isOnMobile: z.boolean(),
    site: z.enum(signupFormSiteTypes),
    utmParams: z.string(),
  }),
  output: z.object({
    form: z.any(), // SignupForm, but making a giant schema for it would cramp my style
    formId: z.string().nullable(),
    skipPhoneSteps: z.boolean(),
    reason: z.string().optional(),
  }),
};
